import Link from "next/link"
import Image from "next/image"
import { Twitter, Github, Send } from "lucide-react"

export function Footer() {
  return (
    <footer className="border-t border-border/30 bg-background/50 backdrop-blur-sm">
      <div className="container py-12 sm:py-16 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-10 md:gap-14">
          {/* Brand - Full width on mobile */}
          <div className="col-span-2 sm:col-span-2 md:col-span-1 space-y-5 mb-4 sm:mb-0">
            <Link href="/" className="flex items-center group">
              {/* Light theme */}
              <Image
                src="/logo.svg"
                alt="TokenKickstarter Logo"
                width={320}
                height={70}
                loading="lazy"
                className="h-33 w-auto transition-transform group-hover:scale-105 dark:hidden"
              />
              {/* Dark theme */}
              <Image
                src="/logo-dark.svg"
                alt="TokenKickstarter Logo"
                width={320}
                height={70}
                loading="lazy"
                className="h-33 w-auto transition-transform group-hover:scale-105 hidden dark:block"
              />
            </Link>
            <p className="text-sm text-muted-foreground max-w-[280px] leading-relaxed">
              The most trusted decentralized launchpad for token presales. Launch your project with confidence.
            </p>
            <div className="flex items-center gap-3">
              <Link
                href="#"
                aria-label="Follow us on Twitter"
                className="flex h-11 w-11 items-center justify-center rounded-xl bg-muted/50 hover:bg-primary/20 transition-all hover:scale-110"
              >
                <Twitter className="h-5 w-5 text-foreground" />
              </Link>
              <Link
                href="#"
                aria-label="Join our Telegram"
                className="flex h-11 w-11 items-center justify-center rounded-xl bg-muted/50 hover:bg-primary/20 transition-all hover:scale-110"
              >
                <Send className="h-5 w-5 text-foreground" />
              </Link>
              <Link
                href="#"
                aria-label="View our GitHub"
                className="flex h-11 w-11 items-center justify-center rounded-xl bg-muted/50 hover:bg-primary/20 transition-all hover:scale-110"
              >
                <Github className="h-5 w-5 text-foreground" />
              </Link>
            </div>
          </div>

          {/* Product */}
          <div className="space-y-3 sm:space-y-4">
            <h3 className="text-sm sm:text-base font-semibold">Product</h3>
            <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
              <li>
                <Link href="/presales" className="text-muted-foreground hover:text-foreground transition-colors">
                  View Presales
                </Link>
              </li>
              <li>
                <Link href="/create-token" className="text-muted-foreground hover:text-foreground transition-colors">
                  Create Token
                </Link>
              </li>
              <li>
                <Link href="/create-presale" className="text-muted-foreground hover:text-foreground transition-colors">
                  Create Presale
                </Link>
              </li>
              <li>
                <Link href="/launch-app" className="text-muted-foreground hover:text-foreground transition-colors">
                  Launch App
                </Link>
              </li>
              <li>
                <Link href="/staking" className="text-muted-foreground hover:text-foreground transition-colors">
                  Staking
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div className="space-y-3 sm:space-y-4">
            <h3 className="text-sm sm:text-base font-semibold">Resources</h3>
            <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
              <li>
                <Link href="/docs" className="text-muted-foreground hover:text-foreground transition-colors">
                  Documentation
                </Link>
              </li>
              <li>
                <Link href="/whitepaper" className="text-muted-foreground hover:text-foreground transition-colors">
                  Whitepaper
                </Link>
              </li>
              <li>
                <Link href="/audit" className="text-muted-foreground hover:text-foreground transition-colors">
                  Audit Reports
                </Link>
              </li>
              <li>
                <Link href="/blog" className="text-muted-foreground hover:text-foreground transition-colors">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div className="space-y-3 sm:space-y-4">
            <h3 className="text-sm sm:text-base font-semibold">Legal</h3>
            <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
              <li>
                <Link href="/terms" className="text-muted-foreground hover:text-foreground transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link href="/privacy" className="text-muted-foreground hover:text-foreground transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link href="/disclaimer" className="text-muted-foreground hover:text-foreground transition-colors">
                  Disclaimer
                </Link>
              </li>
              <li>
                <Link href="/contact" className="text-muted-foreground hover:text-foreground transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 sm:mt-16 pt-8 border-t border-border/30 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
          <p className="text-sm text-muted-foreground">© 2025 TokenKickstarter. All rights reserved.</p>
          <p className="text-sm text-muted-foreground">Built with security and transparency in mind</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
